import React, { Component } from "react";
import StartupCard from "components/common/StartupCard/StartupCard";
import Api from "Api/Api";
import moment from "moment";
import { connect } from "react-redux";
import { Popup } from "devextreme-react";
import ContractForm from "components/common/ContractForm";
import Utils from "Utils";
import AddBidForm from "components/InvestorComponents/AddBidForm";
function mapStateToProps(state) {
  return {
    section: state.section
  };
}
class Contracts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contracts: [],
      moderator: props.moderator,
      showPopup: false,
      showSellForm: false,
      popupData: {}
    };
    this.togglePopup = data => {
      if (data && "id" in data) {
        this.setState({ showSellForm: true, popupData: data });
      }
      this.setState({
        showPopup: !this.state.showPopup
      });
    };
    this.createContract = data => {
      Api.createContract(data).then(response => {
        if (response.status === 201) {
          this.setState({
            contracts: [...this.state.contracts, response.data]
          });
          this.togglePopup();
        } else {
          Utils.notify(response.data[0], "warning");
        }
      });
    };
    this.renderComponent = () => {
      if (this.state.showSellForm) {
        return (
          <AddBidForm
            startup={this.state.popupData}
            upForSale={this.togglePopup}
          />
        );
      }
      return <ContractForm getData={this.createContract} />;
    };
  }
  componentDidMount() {
    if (this.state.moderator) {
      this.props.dispatch({
        type: "SectionSelected",
        payload: "Contracts"
      });
      this.props.dispatch({ type: "toggleLoad" });
      Api.getAllContracts().then(response => {
        if (response.status === 200) {
          this.props.dispatch({ type: "toggleLoad" });
          this.setState({
            contracts: response.data
          });
        }
      });
    } else {
      this.props.dispatch({ type: "toggleLoad" });
      Api.getContractsOfInvestor().then(response => {
        if (response.status === 200) {
          this.props.dispatch({ type: "toggleLoad" });
          this.setState({
            contracts: response.data
          });
          Utils.highlighter(this.props.location.state);
        }
      });
      this.props.dispatch({
        type: "SectionSelected",
        payload: "Invested Startups"
      });
    }
  }

  render() {
    return (
      <div className="card">
        <div className={`card-header card-header-primary`}>
          <div className="row">
            <div className="col-lg-6">
              <div style={{ textTransform: "capitalize" }}>
                <h4>Contracts</h4>
              </div>
            </div>
            {this.state.moderator ? (
              <div
                className="col-lg-6 text-right material-icons pointer"
                onClick={this.togglePopup}
              >
                add_box
              </div>
            ) : null}
          </div>
        </div>
        <div className="card-body">
          {this.state.contracts.length ? (
            this.state.contracts.map(contract => {
              return (
                // <div className="row" id={`contract${contract.id}`}>
                <div className="row" data-highlight={contract.id}>
                  <div className="col-lg-9">
                    <h5 className="text-capitalize fw500">{contract.name}</h5>
                    <h6 className="fw400">Created:</h6>
                    <p>{moment(contract.created).format("LLL")}</p>
                    <h6 className="fw400">Timeline:</h6>
                    <p>{moment(contract.timeline).format("LLL")}</p>
                    <h6 className="fw400">Contract Type:</h6>
                    <p>{contract.contract_type}</p>
                  </div>
                  <div className="col-lg-3">
                    <StartupCard
                      type="committed"
                      data={contract.startup_info}
                      showPopup={this.togglePopup}
                    />
                  </div>
                </div>
              );
            })
          ) : (
            <h4 className="no-data-text">No data</h4>
          )}
        </div>
        <Popup
          title={this.state.showSellForm ? "Sell Stakes" : "Add contract"}
          visible={this.state.showPopup}
          onHiding={this.togglePopup}
          closeOnOutsideClick={true}
          contentComponent={this.renderComponent}
        />
      </div>
    );
  }
}
export default connect(mapStateToProps)(Contracts);
